// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip_tooltip__ycbtL {
  display: inline-block;
  position: relative;
  width: 14px;
  height: 14px;
  margin-left: 5px;
  vertical-align: center; }

.tooltip_icon__0bCM8 {
  fill: #666666;
  transition: all 0.4s;
  cursor: pointer; }
  .tooltip_icon__0bCM8:hover {
    fill: var(--Orange); }

.tooltip_container__zDKiB {
  position: absolute;
  left: 10px;
  top: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
  border-radius: 4px;
  padding: 10px;
  width: 390px;
  z-index: 9999; }
  .tooltip_container__zDKiB .tooltip_title__peRcs {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: #666666; }
  .tooltip_container__zDKiB .tooltip_text__w5Zj7 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px; }
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/tooltip.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB,EAAA;;AAExB;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe,EAAA;EAHjB;IAKI,mBAAmB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa,EAAA;EATf;IAWI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;EAdlB;IAiBI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA","sourcesContent":[".tooltip {\n  display: inline-block;\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin-left: 5px;\n  vertical-align: center;\n}\n.icon {\n  fill: #666666;\n  transition: all 0.4s;\n  cursor: pointer;\n  &:hover {\n    fill: var(--Orange);\n  }\n}\n.container {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n  border-radius: 4px;\n  padding: 10px;\n  width: 390px;\n  z-index: 9999;\n  .title {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 150%;\n    color: #666666;\n  }\n  .text {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip_tooltip__ycbtL`,
	"icon": `tooltip_icon__0bCM8`,
	"container": `tooltip_container__zDKiB`,
	"title": `tooltip_title__peRcs`,
	"text": `tooltip_text__w5Zj7`
};
export default ___CSS_LOADER_EXPORT___;
